"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ToastStore = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _enu = _interopRequireDefault(require("../utils/enu"));

var _ChangeEmitter2 = _interopRequireDefault(require("../base/ChangeEmitter"));

var _DevTools = _interopRequireDefault(require("../utils/DevTools"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _logic = require("./logic");

var _Icon = _interopRequireDefault(require("./Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DEFAULT_TIMEOUT = 3000;
var SUCCESS_MESSAGES = ["Everything went fine!", "All done!", "That went better than expected.", "No server error this time."];
var ERROR_MESSAGES = ["Uh oh.", "That didn't work.", "Something bad happened.", "Bad luck."];

var ToastStoreClass = /*#__PURE__*/function (_ChangeEmitter) {
  _inherits(ToastStoreClass, _ChangeEmitter);

  var _super = _createSuper(ToastStoreClass);

  function ToastStoreClass() {
    var _this;

    _classCallCheck(this, ToastStoreClass);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.toasts = [];

    _this.showToast = function (toast) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var t = _lodash["default"].assign({
        toast: toast
      }, options);

      _this.toasts = _this.toasts.concat(t);

      _this.emitChange();

      if (!options.permanent) {
        setTimeout(function () {
          _this.toasts = _lodash["default"].filter(_this.toasts, function (x) {
            return x !== t;
          });

          _this.emitChange();
        }, options.timeout || DEFAULT_TIMEOUT);
      }
    };

    return _this;
  }

  _createClass(ToastStoreClass, [{
    key: "getToasts",
    value: function getToasts() {
      return this.toasts;
    }
  }]);

  return ToastStoreClass;
}(_ChangeEmitter2["default"]);

var ToastStore = new ToastStoreClass();
exports.ToastStore = ToastStore;

_DevTools["default"].expose({
  ToastStore: ToastStore
});

var ToastDisplay = /*#__PURE__*/function (_React$Component) {
  _inherits(ToastDisplay, _React$Component);

  var _super2 = _createSuper(ToastDisplay);

  function ToastDisplay(props) {
    var _this2;

    _classCallCheck(this, ToastDisplay);

    _this2 = _super2.call(this, props);

    _this2.onData = function () {
      _this2.setState({
        toasts: ToastStore.getToasts()
      });
    };

    _this2.state = {
      toasts: []
    };
    return _this2;
  }

  _createClass(ToastDisplay, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      ToastStore.addChangeListener(this.onData);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      ToastStore.removeChangeListener(this.onData);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "Toast-overlay"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "Toast-area"
      }, _lodash["default"].map(this.state.toasts, function (toast, idx) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: idx,
          className: _lodash["default"].filter(["Toast-box", toast.type === ToastContext.type.SUCCESS && "Toast-box-success", toast.type === ToastContext.type.ERROR && "Toast-box-error"]).join(" ")
        }, /*#__PURE__*/_react["default"].createElement(_logic.If, {
          "if": toast.icon,
          then: function then() {
            return /*#__PURE__*/_react["default"].createElement("div", {
              className: "Toast-icon"
            }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
              icon: toast.icon
            }));
          }
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "Toast-message"
        }, toast.toast));
      })));
    }
  }]);

  return ToastDisplay;
}(_react["default"].Component);

var ToastContext = /*#__PURE__*/function (_React$Component2) {
  _inherits(ToastContext, _React$Component2);

  var _super3 = _createSuper(ToastContext);

  function ToastContext() {
    var _this3;

    _classCallCheck(this, ToastContext);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));

    _this3.showToast = function (toast) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      ToastStore.showToast(toast, options);
    };

    _this3.showSuccess = function (toast, options) {
      return ToastStore.showToast(toast || _lodash["default"].sample(SUCCESS_MESSAGES), _lodash["default"].assign({}, options, {
        type: ToastContext.type.SUCCESS,
        timeout: 3000,
        icon: "person-smile"
      }));
    };

    _this3.showError = function (toast, options) {
      return ToastStore.showToast(toast || _lodash["default"].sample(ERROR_MESSAGES), _lodash["default"].assign({}, options, {
        type: ToastContext.type.ERROR,
        timeout: 20000,
        icon: "undefined"
      }));
    };

    _this3.render = function () {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _this3.props.children, /*#__PURE__*/_react["default"].createElement(ToastDisplay, null));
    };

    return _this3;
  }

  _createClass(ToastContext, [{
    key: "getChildContext",
    value: function getChildContext() {
      return _lodash["default"].pick(this, ["showToast", "showSuccess", "showError"]);
    }
  }]);

  return ToastContext;
}(_react["default"].Component);

ToastContext.type = (0, _enu["default"])(["SUCCESS", "ERROR", "INFO"]);
ToastContext.childContextTypes = {
  showToast: _propTypes["default"].func,
  showSuccess: _propTypes["default"].func,
  showError: _propTypes["default"].func
};
;
var _default = ToastContext;
exports["default"] = _default;